module.exports = __webpack_public_path__ + "static/img/point-color@m.dc9cf41.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/partecs/point-color@m.png
// module id = MH+b
// module chunks = 0